import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15",
      cy: "15",
      r: "14.25",
      fill: "#F8BF1E",
      stroke: "#FFD664",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#5B2F04",
      d: "m22.167 18.078-6.644 4.177v-6.629l2.54-1.634v3.95l1.319-.908v-5.312l-4.299 2.815-4.299-2.815v5.312l1.32.908v-3.95l2.54 1.634v6.629L8 18.078V7l7.083 4.586L22.167 7v11.078Z"
    }, null, -1)
  ]))]))
}
export default { render: render }